import React from "react";
import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  ["Do I need an appointment?", "Monday, Wednesday, Thursday and Saturday are appointment-only. On other days we welcome walk-ins subject to availability, but booking online always guarantees your slot."],
  ["How do I book?", "Head to the Book page, pick your service, choose your barber, then select a date and available time slot. You'll get instant confirmation — no phone calls needed."],
  ["Can I cancel online?", "Cancellations aren't handled through the website. If your plans change, please contact the shop directly by phone or WhatsApp."],
  ["Do you take card or cash?", "Payment is taken in-shop after your service. We don't take online payments — you only pay when you're in the chair."],
  ["Do you cut children's hair?", "Absolutely. Our Kids Cut service is designed for under-12s with patient, friendly barbers."],
  ["Where are you located?", "109 Plungington Road, Preston, PR1 7UE. There's a map on our Contact page."],
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="pt-32 pb-24 max-w-3xl mx-auto px-5 sm:px-8 min-h-screen">
      <Reveal>
        <div className="label-caps mb-3">Good to know</div>
        <h1 className="font-display text-6xl sm:text-7xl tracking-tighter mb-10">FAQs</h1>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="bg-[#141414] border border-white/5 rounded-2xl px-6">
              <AccordionTrigger className="text-left text-lg hover:text-[#D4AF37] hover:no-underline py-5">{q}</AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed pb-5">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal>
        <div className="mt-12 text-center text-gray-400">
          Still have questions? <Link to="/contact" className="text-[#D4AF37]">Get in touch →</Link>
        </div>
      </Reveal>
    </div>
  );
}
